/* ============================================================
   custom.js — Scripts transversaux Cottance
   Chargé en defer sur toutes les pages. Le JS propre à une
   section custom vit dans son fichier liquid quand il est court.
   ============================================================ */

/* Hauteur du header compact (sticky, 1re rangée seulement) → variable CSS
   --header-compact, utilisée par la galerie collante des pages produits. */
(function () {
  function measure() {
    var header = document.querySelector('.theme__header');
    if (!header) return;
    var row2 = header.querySelector('.cottance-header__row2');
    var h = header.getBoundingClientRect().height;
    if (row2 && getComputedStyle(row2).display !== 'none') h -= row2.getBoundingClientRect().height;
    if (h > 0) document.documentElement.style.setProperty('--header-compact', Math.round(h) + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure); else measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
})();
